import React, { Component } from 'react';
import { MLOpsDatasourceFile } from '../../../../domain/mlops/MLOpsDomains';
import FileUploader, { UploadProgress } from '../../../sandbox/FileUploader';
import { dispatch } from '../../../../redux/store';
import { InstanceContainer } from '../../../../config/binding/InstanceBinding';
import Injectables from '../../../../constant/Injectables';
import EnvironmentUtil from '../../../../util/EnvironmentUtil';
import { changeAiModelTrainingFile, changeAiModelValidationFile } from '../../../../redux/actions/AiModelActions';

class MlOpsDatasourceFileComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public render() {
    const { file, percent, progress } = this.state;
    const { datasource } = this.props;
    return (
      <div className='bg-main-gray border border-dashed'>
        {datasource.fileName && file == null && (
          <span>
            <h3>
              You have already uploaded {datasource.fileName} file <br />
              If you upload new file, it will be replaced.
              <br />
            </h3>
          </span>
        )}
        <FileUploader acceptedFiles={['text/csv']} file={file} percent={percent} progress={progress} onChangeFile={this.onChangeFile} maxBytes={this.environmentUtil.getStorageMaxSize()} />
      </div>
    );
  }

  private onChangeFile = (file: File | null) => {
    const { type, datasource, onChange } = this.props;
    if (file) {
      datasource.fileName = file.name;
      datasource.size = file.size;
    }
    if (type == 'TRAINING') {
      dispatch(changeAiModelTrainingFile(file));
    } else {
      dispatch(changeAiModelValidationFile(file));
    }
    onChange(datasource);
    this.setState({ file });
  };
}

class State {
  file: File | null = null;
  percent: number = 0;
  progress: UploadProgress = 'idle';
}

interface Props {
  datasource: MLOpsDatasourceFile;
  onChange: (datasource: MLOpsDatasourceFile, file?: File) => void;
  type: 'VALIDATION' | 'TRAINING';
}

export default MlOpsDatasourceFileComponent;
